var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillingCycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#EFF5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3411_10031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4037 17.2668L14.6071 16.2131C14.8991 16.0735 15.0226 15.7234 14.8831 15.4314C14.7435 15.1392 14.3937 15.0156 14.1018 15.1552L13.2103 15.5815C15.2691 11.4192 20.4222 9.95622 24.3448 12.264C24.6237 12.4281 24.9827 12.3349 25.1468 12.0558C25.3108 11.7767 25.2176 11.4174 24.9388 11.2532C20.3683 8.56431 14.3751 10.3452 12.0795 15.2289L11.6225 14.2723C11.483 13.9801 11.1331 13.8565 10.8412 13.9961C10.5493 14.1357 10.4257 14.4858 10.5652 14.7778L11.6223 16.9907C11.7619 17.2829 12.1118 17.4063 12.4037 17.2668Z",
    fill: "#99A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6836 26.9074L20.6697 25.5251C20.403 25.342 20.0381 25.4099 19.855 25.6768C19.6719 25.9438 19.74 26.3088 20.0067 26.4919L20.8337 27.0597C16.3983 27.3534 12.3323 23.7795 12.3824 19.0613C12.3857 18.7375 12.1262 18.4724 11.8027 18.4688C11.4867 18.4632 11.214 18.72 11.2105 19.0488C11.1524 24.5353 15.9245 28.6533 21.0748 28.2174L20.4822 29.0815C20.2991 29.3485 20.367 29.7135 20.6338 29.8966C20.9007 30.0797 21.2656 30.0118 21.4485 29.7448L22.8352 27.7225C23.0182 27.4556 22.9504 27.0907 22.6836 26.9074Z",
    fill: "#99A4A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.501 13.4626C29.526 13.1399 29.2849 12.8578 28.9623 12.8327L26.5183 12.6423C26.1962 12.6181 25.9138 12.8584 25.8888 13.1813L25.6991 15.6173C25.6727 15.957 25.9406 16.2492 26.284 16.2492C26.5869 16.249 26.8435 16.0156 26.8675 15.7084L26.9438 14.7274C29.4952 18.5706 28.2261 23.7559 24.2582 26.0238C23.9773 26.1843 23.8796 26.5424 24.0402 26.8235C24.2007 27.1047 24.5585 27.2024 24.8396 27.0419C29.4827 24.3882 30.8659 18.314 27.8115 13.919L28.8712 14.0016C29.1935 14.0264 29.4758 13.7855 29.501 13.4626Z",
    fill: "#99A4A3"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E9F1F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3411_10031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingCycle);
export default __webpack_public_path__ + "static/media/billingCycle.c0e89734934c4ac381c3c2caa7802e9c.svg";
export { ForwardRef as ReactComponent };